export enum Channel {
  CTV = 'CTV',
  OLV = 'OLV',
  Display = 'Display',
  Audio = 'Audio',
  SpotifyDirect = 'Direct Audio',
  Dooh = 'Dooh',
  Google = 'Google',
  Gaming = 'Gaming',
  Amazon = 'Amazon',
  GamVideo = 'GAM Video',
  GamDisplay = 'GAM Display',
}

export default Channel;
